export const FILTER_PRICE_START = 0;

export const FILTER_PRICE_END = 2500000;

export const FILTER_PRICE_STEP = 5000;

export const FILTER_KM_START = 0;

export const FILTER_KM_END = 2500000;

export const FILTER_KM_STEP = 50000;

export const FILTER_REGISTRATION_YEAR_START = 1980;

export const FILTER_REGISTRATION_YEAR_END = Number(new Date().getFullYear());

export const FILTER_REGISTRATION_YEAR_STEP = 1;

export const FILTER_LENGTH_START = 5;

export const FILTER_LENGTH_END = 19;

export const FILTER_LENGTH_STEP = 0.1;

export const FILTER_SEATS_VALUES = [5, 10, 15, 20, 30, 40, 50, 60, 70, 80, 90, 100, 120, 140];

export const EMPTY_OPTION_VALUE = 'EMPTY_OPTION';
